import React, { useState } from 'react';
import './ImageWithLoader.css';

// Componente para mostrar un esqueleto de carga
const SkeletonLoader = () => {
  return (
    <div className="skeleton-card">
      <div className="skeleton skeleton-image"></div>
    </div>
  );
};

// Componente para mostrar una imagen con esqueleto de carga
const ImageWithLoader = ({ src, alt, className }) => {
  const [loading, setLoading] = useState(true);

  return (
    <div className={`image-container ${className}`}>
      {loading && <SkeletonLoader />}
      <img
        src={src}
        alt={alt}
        onLoad={() => setLoading(false)}
        style={{ display: loading ? 'none' : 'block' }}
      />
    </div>
  );
};

export default ImageWithLoader;
